var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BButton',{staticClass:"mr-2",attrs:{"size":_vm.size,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();return _vm.downloadFile.apply(null, arguments)}}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.text)?_c('span',{class:{'ml-3': _vm.icon !== null}},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }